






































import Thumbnail from '../../components/Thumbnail.vue';
import AulaCard from '../../components/AulaCard.vue';
import { PropType } from 'vue';
import { AlbumModel } from '../../models/album.model';
import Icon from '../../components/Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import { DateTimeUtil } from '../../utils/dateTimeUtil';

export default {
  components: { Icon, AulaCard, Thumbnail },
  props: {
    album: { type: Object as PropType<AlbumModel>, required: true },
    showSelectBox: { type: Boolean, default: false },
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    createdAt() {
      return DateTimeUtil.formatDate(this.album.creationDate, 'DD. MMMM YYYY');
    },
    isChecked() {
      return this.album.selected;
    },
  },
};
